<script lang="ts">
  import { DECK, type NodeId } from "@spacecrew/shared";
  import { ship } from "../net/ship.svelte.js";
  import { session } from "../net/session.svelte.js";

  const crew = $derived(Object.entries(ship.snap!.crew));
</script>

<section aria-labelledby="crew-title">
  <h2 id="crew-title">CREW MANIFEST</h2>
  <ul>
    {#each crew as [id, c] (id)}
      <li class={c.connected ? "" : "dim"}>
        {c.name}{id === session.sessionId ? " (YOU)" : ""}
        <span class="dim">[CONTRACTOR]</span>
        — {c.toNodeId ? `IN TRANSIT → ${DECK.nodes[c.toNodeId as NodeId].label}` : DECK.nodes[c.nodeId as NodeId].label}
        {#if !c.connected}<span class="bad">OFF-LINK</span>{/if}
      </li>
    {/each}
  </ul>
</section>

<style>
  ul { list-style: none; padding: 0; margin: 0; display: grid; gap: 0.2rem; }
</style>
